import React, {useState, useEffect, useRef} from 'react'
import styled from 'styled-components';
import i18n from 'live/services/i18n';
import { DrillDownEvent } from '../../types';
import Geocoding from '../../classes/Geocoding';
import { Lookup } from '../../DrillDownMap';
import { Information, buildInformation, iniInformations } from './utils';

type IProps = {
    height: number
    allEvents: DrillDownEvent[]
    activeEvent: DrillDownEvent
    extensionQualifier?:string
}

let geocoding: Geocoding = new Geocoding()

const PointInformation = ({height = 0, allEvents = [], activeEvent, extensionQualifier}: IProps): JSX.Element => {

    const [isOpen, setOpen] = useState<boolean>(true)
    const [informations, setInformations] = useState<Information[]>(iniInformations)

    useEffect(() => {
        geocoding.setQualifier(extensionQualifier)
    }, [extensionQualifier])
    
    useEffect(() => {
        let geocoding: Geocoding = new Geocoding(extensionQualifier)

        buildInformation(geocoding, activeEvent, allEvents).then(res => {
            setInformations(res)
        })
    }, [activeEvent, allEvents, extensionQualifier])
    
    return <Details  open={isOpen}>
            <Wrapper open={isOpen}>
                <Content height={height}>
                    {
                        informations?.map(({title, value}, index) => {
                            return <div key={index}  className='information-item'>
                                <div data-testid={"test-title-" + index} className='information-item-title'>{i18n(title)}:</div>
                                <div data-testid={"test-value-" + index}  className='information-item-value'>{value}</div>
                            </div>
                        })
                    }
                </Content>
            </Wrapper>
            
            <DetailsSideRight onClick={() => setOpen(curr => !curr)}>                            
                <i className={`fas fa-chevron-${isOpen ? 'left' : 'right'}`}></i>
                <div className='rotate'>{i18n('Point Information')}</div>
            </DetailsSideRight>
        </Details>
}

export default React.memo(PointInformation);

const Details = styled.div`
    display: flex;    
    transition: width 0.1s ease-in;
    border: 1px solid rgba(0,0,0,0.1);
    width:${({open}) => open ? '263px' : '47px'};
`

const Wrapper = styled.div`
    flex: 1;
    width: ${({open}) => open ? "263px" : "0"};
    overflow: hidden;
`

const Content = styled.div`
    flex: 1;
    padding: 16px;   
    overflow: hidden;
    overflow-y: scroll; 
    height: ${({height}) => `${height}px`};

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #bac0cb;
        border-radius: 10px;
    }

    .information-item{
        margin-bottom: 16px;

        .information-item-title{
            color: ${({theme}) => theme['gray-600']};
            font-size: 11px;
        }

        .information-item-value{
            color: ${({theme}) => theme['gray-700']};
            font-size: 13px;
        }
    }
`

const DetailsSideRight = styled.div`
    height: 100%;
    width: 47px;
    font-size: 14px;
    cursor: pointer;
    padding-top: 15px;
    text-align: center;
    border: 1px solid rgba(0,0,0,0.1);
    color: ${({theme}) => theme['blue-500']};

    i{
        margin-bottom: 15px;
        font-size: 14px;
    }

    .rotate{
        font-weight: 600;
        writing-mode: vertical-rl;
        transform: scale3d(-1, -1, 1);
        position: relative;
        left: 13px;
    }
`

